import React from 'react';
import { View, StyleSheet } from 'react-native';
// import { deviceHeight, deviceWidth } from './../utils';

const deviceWidth = window.innerWidth;

const getSize = val => {
    const _val = val/100;
    let width = deviceWidth * _val
    if(isNaN(width) || typeof width !== 'number') width = 0;
    return width;
}


export default ({bg='#e0ebf3', zIndex=-1, size=0, style={}}) => {
    const _size = getSize(size);
    return (
        <View
        style={[styles.bgCircle, {
            width: _size,
            height: _size,          
            zIndex,
            backgroundColor: bg,
            position: 'absolute',
            borderRadius: _size,
            ...style                
        }]}
    />   
    )
}


const styles = StyleSheet.create({
    bgCircle: {
        position: 'absolute',
        zIndex: -1,
        borderRadius: 100
    }
})

